const Footer = () => {
  return (
    <div className="card footer">
      <h2>FindGits | by shaikh_md | &copy; 2022</h2>
      <a
        href="https://github.com/shaikhmd007/Find_Gits"
        target="_blank"
        rel="noreferrer"
      >
        Github Source Code
      </a>
      <p> Made with ❤️ &amp; 💻</p>
    </div>
  );
};

export default Footer;
